import React, { useRef, useState } from 'react';
import { api } from '../../services/api';

/**
 * Upload a document to an existing payment request. Allowed in any status.
 * Mirrors the create-form flow: getUploadUrl -> PUT to S3 -> confirmUpload.
 */
export default function UploadButton({ paymentRequestId, user, onUploaded, className }) {
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);

  const handlePick = () => inputRef.current?.click();

  const handleChange = async (e) => {
    const files = Array.from(e.target.files || []);
    if (files.length === 0) return;
    setUploading(true);
    try {
      for (const file of files) {
        const contentType = file.type || 'application/octet-stream';
        const { url, s3Key } = await api.getUploadUrl(user.credential, paymentRequestId, file.name, contentType);
        await fetch(url, { method: 'PUT', body: file, headers: { 'Content-Type': contentType } });
        await api.confirmUpload(user.credential, paymentRequestId, s3Key, file.name, file.type);
      }
      if (onUploaded) onUploaded();
    } catch (err) {
      console.error(err);
      alert('העלאת הקובץ נכשלה');
    } finally {
      setUploading(false);
      if (inputRef.current) inputRef.current.value = '';
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        multiple
        style={{ display: 'none' }}
        onChange={handleChange}
      />
      <button type="button" className={className} onClick={handlePick} disabled={uploading} title="העלה מסמך">
        {uploading ? 'מעלה...' : '📎 העלה מסמך'}
      </button>
    </>
  );
}
